import { isInternalSite, cookies, featuresPromise } from './utility';
import { getLmsPromise, getAsdel } from './services';

const wirePermissions = [
    'us.registerAssociate.register',
    'us.ordermanagement.orderDetail:READ',
    'us.ordermanagement.orderResolution:READ',
    'us.ghs.storeOrders:READ',
    'us.ghs.avail-slotavailabilityNew:READ',
    'us.ghs.availNew:READ',
    'us.swift.swiftDashboard:SWIFT-STORE_OPERATIONS_MANAGER',
];

const getBucketDetails = async (market, permissionData, setBucketsLookupCallback) => {
    let marketFeatures;
    const features = await featuresPromise;
    if (isInternalSite()) marketFeatures = features[market];
    else marketFeatures = features[`${market}_ext`];

    const bucketData = {};

    // Create Buckets
    for (let i = 0; i < permissionData.length; i++) {
        const splitPerm = permissionData[i].split(':');

        const bucktDt = splitPerm[0];
        // To check the validity of Options

        if (!bucktDt) {
            continue;
        }

        const splitTabs = bucktDt.split('.');

        // To check if the valid market is provided
        if (splitTabs && market != splitTabs[0]) {
            continue;
        }

        const deriveBucket = splitTabs[1];

        if (!marketFeatures[deriveBucket]) {
            continue;
        }

        // Create new Object for capturing Buckets
        if (!bucketData[deriveBucket]) {
            bucketData[deriveBucket] = {};
        }

        bucketData[deriveBucket].name = marketFeatures[deriveBucket].name;
        bucketData[deriveBucket].allowSolo = marketFeatures[deriveBucket].allowSolo || false;
        bucketData[deriveBucket].route = marketFeatures[deriveBucket].route;
        bucketData[deriveBucket].icon = marketFeatures[deriveBucket].iconv2;
        if (marketFeatures[deriveBucket].contextualLSP)
            bucketData[deriveBucket]['contextualLSP'] = marketFeatures[deriveBucket].contextualLSP;
        if (marketFeatures[deriveBucket]['followSequence'])
            bucketData[deriveBucket]['followSequence'] = marketFeatures[deriveBucket]['followSequence'];
        if (marketFeatures[deriveBucket]['childPages'])
            bucketData[deriveBucket]['childPages'] = marketFeatures[deriveBucket]['childPages'];

        const derivePages = splitTabs[2].split('-');
        const derivePg = derivePages[0];
        const deriveSubpg = derivePages[1];

        //Capturing Bucket details

        if (!bucketData[deriveBucket].pages) {
            bucketData[deriveBucket].pages = {};
        }

        if (typeof marketFeatures[deriveBucket].pages === 'object') {
            if (typeof marketFeatures[deriveBucket]['pages'][derivePg] === 'object') {
                const sourcedataPg = marketFeatures[deriveBucket].pages;
                const bucketPage = bucketData[deriveBucket].pages;

                if (typeof bucketPage[derivePg] !== 'object') {
                    bucketPage[derivePg] = {};
                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg].name) {
                        bucketPage[derivePg].name = sourcedataPg[derivePg].name;
                    }
                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg].route) {
                        bucketPage[derivePg].route = sourcedataPg[derivePg].route;
                    }
                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg].icon) {
                        bucketPage[derivePg].icon = sourcedataPg[derivePg].icon;
                    }

                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg].hiddenPage) {
                        bucketPage[derivePg].hiddenPage = sourcedataPg[derivePg].hiddenPage;
                    }
                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg]._order) {
                        bucketPage[derivePg]._order = sourcedataPg[derivePg]._order;
                    }
                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg].sNo) {
                        bucketPage[derivePg].sNo = sourcedataPg[derivePg].sNo;
                    }
                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg].childPages) {
                        bucketPage[derivePg].childPages = sourcedataPg[derivePg].childPages;
                    }
                    if (marketFeatures[deriveBucket].contextualLSP) {
                        bucketPage[derivePg].contextualLSP = marketFeatures[deriveBucket].contextualLSP;
                    }
                }

                if (deriveSubpg) {
                    if (sourcedataPg[derivePg] && sourcedataPg[derivePg].pages) {
                        if (sourcedataPg[derivePg].pages[deriveSubpg]) {
                            if (typeof bucketPage[derivePg].pages !== 'object') {
                                bucketPage[derivePg].pages = {};
                            }

                            bucketPage[derivePg].pages[deriveSubpg] = {};
                            bucketPage[derivePg].pages[deriveSubpg].name =
                                sourcedataPg[derivePg].pages[deriveSubpg].name;
                            bucketPage[derivePg].pages[deriveSubpg].route =
                                sourcedataPg[derivePg].pages[deriveSubpg].route;
                            bucketPage[derivePg].pages[deriveSubpg].icon =
                                sourcedataPg[derivePg].pages[deriveSubpg].icon;
                            bucketPage[derivePg].pages[deriveSubpg].hiddenPage =
                                sourcedataPg[derivePg].pages[deriveSubpg].hiddenPage;
                            if (sourcedataPg[derivePg].pages[deriveSubpg].childPages) {
                                bucketPage[derivePg].pages[deriveSubpg].childPages =
                                    sourcedataPg[derivePg].pages[deriveSubpg].childPages;
                            }
                            if (sourcedataPg[derivePg].pages[deriveSubpg].sNo) {
                                bucketPage[derivePg].pages[deriveSubpg].sNo =
                                    sourcedataPg[derivePg].pages[deriveSubpg].sNo;
                            }
                            if (marketFeatures[deriveBucket].contextualLSP) {
                                bucketPage[derivePg].pages[deriveSubpg].contextualLSP =
                                    marketFeatures[deriveBucket].contextualLSP;
                            }
                        }
                    }
                }
            }
        }
    }

    const bucketLookupObj = {};

    Object.keys(bucketData).forEach(function (key) {
        bucketData[key].solo = true;
        let pc = 0;

        Object.keys(bucketData[key].pages).forEach(function (page) {
            if (pc == 0) {
                bucketData[key].soloPageName = bucketData[key].pages[page].name;
                bucketData[key].soloPage = page;
            }

            if (pc > 1) {
                bucketData[key].solo = false;
            }
            pc++;
        });

        if (Object.keys(bucketData[key].pages).length) {
            bucketLookupObj[key] = bucketData[key];
        }
    });

    if (cookies.get('auth-src') === 'wire') {
        checkBucketsForStore(bucketLookupObj, setBucketsLookupCallback);
    }

    return bucketLookupObj;
};

const checkBucketsForStore = (bucketsObj, setBucketsLookupCallback) => {
    const storeNo = cookies.get('store-no');
    getAsdel()
        .then(({ data }) => {
            if (data.payload && data.payload.stores && data.payload.stores.length) {
                const adStores = data.payload.stores[0].stores;
                const adStoresArray = adStores.split(',');

                if (adStoresArray.indexOf(storeNo) == -1) {
                    delete bucketsObj.registerAssociate;
                    setBucketsLookupCallback({ ...bucketsObj });
                }
            }
        })
        .catch((e) => bucketsObj);

    getLmsPromise(storeNo)
        .then(({ data }) => {
            if (!(data.status === 'OK' && data.payload.id)) {
                delete bucketsObj.swift;
                setBucketsLookupCallback({ ...bucketsObj });
            }
        })
        .catch((e) => bucketsObj);
};

const getPermittedRoutes = (bucketJson, routePermissions = []) => {
    if (!bucketJson) {
        return routePermissions;
    }

    for (const key in bucketJson) {
        if (bucketJson[key].route) {
            routePermissions.push(bucketJson[key].route);
        }

        if (typeof bucketJson[key].pages === 'object') {
            getPermittedRoutes(bucketJson[key].pages, routePermissions);
        }
    }

    return routePermissions;
};

export { getBucketDetails, getPermittedRoutes, wirePermissions };
